/* eslint-disable no-undef */
window.grapesjs = require('grapesjs');
require('grapesjs-preset-webpage');
require('grapesjs-lory-slider');


// WEBPACK FOOTER //
// ./src/includes.js